export const TIME_FORMATS = {
    'HH:mm:ss': 'HH:mm:ss',
    'HH:mm a': 'HH:mm a',
    'HH:mm A': 'HH:mm A',
    'hh:mm a': 'hh:mm a',
    'HH:mm': 'HH:mm',
    'HHh mmmin': 'HH[h] mm[min]',
};
